import React from 'react';
import Classes from './styles/style.module.css';

const BackDrop = (props) => {
    return (
        props.show ?
            <div className={Classes.backDrop} onClick={props.toggleMenu}>
            </div>
            : null
    );
}

export default BackDrop;
